// To use :
//   assign the outermost element the class '.line-to-hide-js'
//   give the checkbox for :_destroy the class '.toggle-checkbox-js'
//   give the element that is the action for deletion '.destroy-nested-association-button-js'
//   if the element is persisted, assign it's :id the class '.database-id-js'
//
//   and then do observe the button like so:
//     $('.destroy-nested-association-button-js').on 'click', (event) =>
//       Sprinkles.DestroyNestedAssociationButton.hideAndToggle event
//
const DestroyNestedAssociationButton = {
  hideAndToggle(e, callback) {
    // setup elements we care about
    const destroyButton = $(e.target)
    const lineToHide = destroyButton.closest(".line-to-hide-js")
    const elementDatabaseId = lineToHide.find(".database-id-js")
    const checkboxToSet = lineToHide.find(".toggle-checkbox-js")

    // if the thing hasn't been persisted, we can just remove it from DOM
    if (elementDatabaseId.val() === "") {
      lineToHide.remove()
    } else {
      Sprinkles.Checkbox.set(checkboxToSet, true)
      lineToHide.addClass("hide")
    }

    // allow hooks after destroy
    if (callback) {
      return callback()
    }
  }
}

export default DestroyNestedAssociationButton
